//验证码类型
export const CaptchaType = {
    UserRegister: 1,//用户注册
    ResetPassword: 2,//重置密码
    UserLogin: 5,//用户登录
};

//订单状态
export const OrderStatus = {
    Close: -3,//订单关闭
    PendingPay: 0,//待支付
    PendingSend: 1,//待发货
    Delivered: 2,//已发货
    Completed: 3,//已完成
    PendingGroup: 4,//待成团
};

export const MchType = {
    ZiKun: 1,//紫鲲商户
    ZiYou: 2,//自有商户
};

//产品类型
export const ProductType = {
    PrizeUnlock: 1,//一元解锁
    Distri: 2,//分销
    Groupbuy: 3,//拼团
    CustomerFission: 4,//客户裂变
    ChatFission: 5,//社群裂变
    RedPacketFission: 6,//红包裂变
    LotteryFission: 7,//抽奖裂变
    GroupRed: 8,//社群红包
    SeatPurchase:1001,//企微助手pro席位
};

export const getProducName = (type) => {
    switch (type) {
        case ProductType.PrizeUnlock:
            return '一元解锁';
        case ProductType.Distri:
            return '分销';
        case ProductType.Groupbuy:
            return '拼团';
        case ProductType.CustomerFission:
            return '客户裂变';
        case ProductType.ChatFission:
            return '社群裂变';
        case ProductType.RedPacketFission:
            return '红包裂变';
        case ProductType.LotteryFission:
            return '抽奖裂变';
        case ProductType.GroupRed:
            return '社群红包';
        case ProductType.SeatPurchase :
            return '企微助手pro席位';
        default:
            return '';
    }
};

export const IMMessageType = {
    GetConversationData: 7000,//获取对话框热数据
    ConversationData: 7001,//对话框热数据
    BindUser:7002,//绑定用户数据
    Beat:7003,//心跳
    SetCurrentChatKey:7004,//设置当前会话
    SendMessage:7005,//发送聊天消息
    BeatReturn:7006,//心跳返回
    NewMsg:7008,//新消息
    SnapShotMsg:7009,//消息快照
    AccountMsgNum:7012,//账号消息数字
    ApplyRecallMsg:7010,//撤回消息
    ApplyRecallResult:7011,//撤回消息
    SetCurrentWxId:7013,//绑定微信ID
    UpdateRoomReturn:7014,//修改群名称返回
    RemoveMemberReturn:7015,//删除群成员
    LoginMsg:7019, //登录
    LoginOut:7020, //登出
    OPEN_CHAT:7021.,//打开聊天
    CLOSE_CHAT:7022,//关闭会话
    Notice:7023,//消息提醒
    SendFail_Not_InRoom:7016, //发消息失败不在群里
    SendFail_Not_Friend:7018, //发消息失败不在群里
    RESEND:7024, //重新发送
    MSG_SUCCESS:7025, //消息结果
}